import { BaseMediaElementAudioPlayer, PlayerEvent } from './types';

const SUPPORTED_EVENTS: PlayerEvent[] = [
  'canplay',
  'ended',
  'loadedmetadata',
  'pause',
  'play',
  'playing',
  'seeked',
  'timeupdate',
  'waiting',
];

/*
 * Audio player that is driven by an HTMLMediaElement.
 *
 * The BaseMediaElementAudioPlayer interface is used to provide access to
 * this.element to mixins
 */
export default class MediaElementAudioPlayer
  implements BaseMediaElementAudioPlayer
{
  constructor(public element: HTMLMediaElement) {}

  public on<T extends keyof HTMLMediaElementEventMap>(
    type: T,
    listener: (this: HTMLMediaElement, ev: HTMLMediaElementEventMap[T]) => void,
    opts?: boolean | AddEventListenerOptions,
  ) {
    this.element.addEventListener(type, listener, opts);
  }

  public off<T extends keyof HTMLMediaElementEventMap>(
    type: T,
    listener: (this: HTMLMediaElement, ev: HTMLMediaElementEventMap[T]) => void,
    opts?: boolean | AddEventListenerOptions,
  ) {
    this.element.removeEventListener(type, listener, opts);
  }

  public supports(event: string) {
    return SUPPORTED_EVENTS.includes(
      event as (typeof SUPPORTED_EVENTS)[number],
    );
  }

  public play() {
    return this.element.play();
  }

  public pause() {
    this.element.pause();
  }

  public ready() {
    return Promise.resolve();
  }

  public seek(seconds: number) {
    this.element.currentTime = seconds;
  }

  public get isReady() {
    return true;
  }

  public get paused() {
    return this.element.paused;
  }

  public currentTime() {
    return this.element.currentTime;
  }

  public get duration() {
    return this.element.duration;
  }

  public set volume(value: number) {
    this.element.volume = value;
  }

  public get volume() {
    return this.element.volume;
  }
}
